"use client";
import { useState, useEffect, useCallback } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

export default function Sidebar({ user, avatar, Logout }) {
    const router = useRouter();
    const searchParams = useSearchParams();
    const [activeSection, setActiveSection] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // Get the current section from URL search params
    useEffect(() => {
        const section = searchParams.get('section') || '';
        setActiveSection(section);
    }, [searchParams]);

    // Handle navigation to different sections
    const handleNavigation = useCallback((section) => {
        try {
            const currentUrl = new URL(window.location.href);
            if (section) {
                currentUrl.searchParams.set('section', section);
            } else {
                currentUrl.searchParams.delete('section');
            }
            router.push(currentUrl.pathname + currentUrl.search);
        } catch (error) {
            console.error('Navigation error:', error);
            // Fallback navigation
            router.push(`/account${section ? `?section=${section}` : ''}`);
        }
    }, [router]);

    const handleDeleteClick = () => {
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = () => {
        setShowDeleteModal(false);
        handleNavigation('deleteAccount');
    };

    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
    };

    // Desktop sidebar
    return (
        <div className="accountSidebar col-12 col-md-4 col-xl-3 px-0">
            <div className='card rounded-4 shadow-sm p-4'>
                <h1 className='text-center mx-auto'>مرحباً : <b>{user?.name}</b> 👋 </h1>
                {/* {avatar && (
                    <img src={avatar} alt="avatar" className="mx-auto rounded-circle mb-2" width={96} height={96} />
                )} */}
                رابط حسابك: <a href={`/@${user?.slug ? user?.slug : user?.username}`} rel="noopener noreferrer" className='text-decoration-none text-muted'>https://figmawya.com/@{user?.slug ? user?.slug : user?.username}</a>
                
                {/* Sidebar Menu */}
                <nav aria-label="Account navigation">
                    <ul className="list-group mt-4">
                        <li className={`list-group-item ${activeSection === 'myLinks' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('myLinks')} 
                                className="text-decoration-none text-dark border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'myLinks'}
                            >
                                <i className='bi bi-link-45deg'></i>  الروابط المختصرة
                            </button>
                        </li>
                        {/* <li className={`list-group-item ${activeSection === 'challenges' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('challenges')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'challenges'}
                            >
                                <i className='bi bi-trophy'></i> التحديات اليومية
                            </button>
                        </li> */}
                        {/* <li className={`list-group-item ${activeSection === 'achievements' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('achievements')} 
                                className="text-decoration-none  text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'achievements'}
                            >
                                <i className='bi bi-award'></i> الشهادات والإنجازات
                            </button>
                        </li> */}
                        {/* <li className={`list-group-item ${activeSection === 'workSamples' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('workSamples')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'workSamples'}
                            >
                                <i className='bi bi-brush'></i>  نماذج أعمالي
                            </button>
                        </li> */}
                        {/* <li className={`list-group-item ${activeSection === 'favorites' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('favorites')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'favorites'}
                            >
                                <i className='bi bi-bookmark-heart'></i>  المفضلة والمحفوظات
                            </button>
                        </li> */}
                        {/* <hr /> */}
                        {/* Content Management Section */}
                        {/* <li className="list-group-item">
                            <h6 className="mb-2 text-muted"><i className='bi bi-collection'></i> إدارة المحتوى</h6>
                        </li>
                        {(user?.roles?.includes('administrator') || user?.roles?.includes('commadmin')) && (
                            <li className={`list-group-item ${activeSection === 'myContent' ? 'active' : ''}`}>
                                <button 
                                    onClick={() => handleNavigation('myContent')} 
                                    className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                    aria-pressed={activeSection === 'myContent'}
                                >
                                    <i className='bi bi-gear'></i> إدارة المحتوى الشاملة
                                </button>
                            </li>
                        )}
                        <li className={`list-group-item ${activeSection === 'templates' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('templates')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'templates'}
                            >
                                <i className='bi bi-file-earmark-text'></i> القوالب
                            </button>
                        </li>
                        <li className={`list-group-item ${activeSection === 'plugins' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('plugins')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'plugins'}
                            >
                                <i className='bi bi-puzzle'></i> الإضافات
                            </button>
                        </li>
                        <li className={`list-group-item ${activeSection === 'articles' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('articles')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'articles'}
                            >
                                <i className='bi bi-journal-text'></i> المقالات
                            </button>
                        </li>
                        <li className={`list-group-item ${activeSection === 'jobs' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('jobs')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'jobs'}
                            >
                                <i className='bi bi-briefcase'></i> الوظائف
                            </button>
                        </li>
                        <li className={`list-group-item ${activeSection === 'projects' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('projects')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'projects'}
                            >
                                <i className='bi bi-folder'></i> المشاريع
                            </button>
                        </li>
                        <li className={`list-group-item ${activeSection === 'surveys' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('surveys')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'surveys'}
                            >
                                <i className='bi bi-clipboard-data'></i> الاستبيانات
                            </button>
                        </li>
                        <li className={`list-group-item ${activeSection === 'podcasts' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('podcasts')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'podcasts'}
                            >
                                <i className='bi bi-mic'></i> بودكاست
                            </button>
                        </li>
                        <li className={`list-group-item ${activeSection === 'videos' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('videos')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'videos'}
                            >
                                <i className='bi bi-camera-video'></i> فيديوهات
                            </button>
                        </li> */}
                        {/* <hr />
                        <li className="list-group-item">
                            <button 
                                onClick={() => handleNavigation('support')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'support'}
                            >
                                <i className='bi bi-chat-text'></i>  الطلبات والدعم
                            </button>
                        </li>
                        <hr /> */}
                        <li className={`list-group-item ${activeSection === 'accountSettings' ? 'active' : ''}`}>
                          
                            <button 
                                onClick={() => handleNavigation('accountSettings')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'accountSettings'}
                            >
                                <i className='bi bi-gear'></i> إعدادات الحساب
                            </button>
                        </li>
                        <li className="list-group-item">
                            <button 
                                onClick={() => handleNavigation('security')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'security'}
                            >
                                <i className='bi bi-lock'></i>  الأمان وكلمة المرور
                            </button>
                        </li>
                        <li className="list-group-item">
                            <button 
                                onClick={() => handleNavigation('privacy')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'privacy'}
                            >
                                <i className='bi bi-eye-slash'></i> الخصوصية
                            </button>
                        </li>
                        {/* <li className={`list-group-item ${activeSection === 'googleLink' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('googleLink')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'googleLink'}
                            >
                                <i className='bi bi-google'></i> ربط حساب Google
                            </button>
                        </li> */}
                        {(process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_SHOW_APPLE_WALLET === 'true') && (
                        <li className={`list-group-item ${activeSection === 'appleWallet' ? 'active' : ''}`}>
                            <button 
                                onClick={() => handleNavigation('appleWallet')} 
                                className="text-decoration-none text-muted border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'appleWallet'}
                            >
                                <i className='bi bi-wallet2'></i> البطاقة في Apple Wallet
                            </button>
                        </li>
                        )}
                        {/* <li className="list-group-item">
                            <button 
                                onClick={() => handleNavigation('notifications')} 
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-pressed={activeSection === 'notifications'}
                            >
                                <i className='bi bi-bell'></i> إعدادات الإشعارات
                            </button>
                        </li> */}
                        
                        <li className={`list-group-item ${activeSection === 'deleteAccount' ? 'active' : ''}`}>
                            <button 
                                onClick={handleDeleteClick} 
                                aria-pressed={activeSection === 'deleteAccount'}
                                className="text-decoration-none text-muted opacity-50 border-0 bg-transparent w-100 text-start"
                                aria-label="حذف الحساب"
                            >
                                <i className='bi bi-trash'></i> حذف الحساب 
                            </button>
                        </li>
                        {/* <hr /> */}
                        <li className="list-group-item">
                            <button 
                                className="btn p-0 text-decoration-none text-danger border-0" 
                                onClick={Logout}
                                aria-label="تسجيل الخروج"
                            >
                                <i className='bi bi-box-arrow-left'></i> تسجيل الخروج
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

            {/* Delete Account Confirmation Modal */}
            <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} 
                 style={{ display: showDeleteModal ? 'block' : 'none' }} 
                 tabIndex="-1" 
                 role="dialog"
                 aria-labelledby="sidebarDeleteModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-light border">
                        <div className="modal-header border-0">
                            <h5 className="modal-title text-danger" id="sidebarDeleteModalLabel">
                                <i className="bi bi-exclamation-triangle"></i> تأكيد حذف الحساب
                            </h5>
                            <button type="button" className="btn-close" onClick={handleDeleteCancel} aria-label="إغلاق"></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className="mb-3">
                                <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
                            </div>
                            <h6 className="mb-3">أنت تحاول حذف حسابك</h6>
                            <p className="text-muted">هل أنت متأكد من أنك تريد المتابعة إلى صفحة حذف الحساب؟</p>
                        </div>
                        <div className="modal-footer border-0 justify-content-center">
                             <button type="button" className="btn btn-outline-secondary" onClick={handleDeleteConfirm}>
                                <i className="bi bi-check-circle"></i> تأكيد
                            </button>
                            <button type="button" className="btn btn-danger me-2" onClick={handleDeleteCancel}>
                                <i className="bi bi-x-circle"></i> إلغاء
                            </button>
                           
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Backdrop */}
            {showDeleteModal && <div className="modal-backdrop fade show"></div>}
        </div>
    );
}
